<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>Ton 比例配置</span>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="比例配置" name="first">
            <el-button v-permisaction="['config:card-coefficient:add']" style="margin-bottom: 1rem" size="mini" type="primary" @click="onSubmit('first')">保存</el-button>
            <ClearCacheApply />
            <syncVersion :in-method="syncSkuOss" />
            <div>
              <el-form :inline="true">
                <el-form-item label="">
                  <el-button style="display: inline-block;margin-bottom: 1rem" size="mini" type="primary" @click="onCount()">计算</el-button>
                </el-form-item>
                <el-form-item label="汇率(Ton->$)">
                  <el-input-number v-model.trim="tonExchangeRate.exchangeRate" size="mini" :controls="false" placeholder="汇率" />
                </el-form-item>
                <el-form-item label="Ton系数">
                  <el-input-number v-model.trim="tonExchangeRate.coefficient" size="mini" :controls="false" placeholder="TON" />
                </el-form-item>
                <el-form-item label="汇率(Star->$)">
                  <el-input-number v-model.trim="tonExchangeRate.starExchangeRate" size="mini" :controls="false" placeholder="汇率" />
                </el-form-item>
                <el-form-item label="Star系数">
                  <el-input-number v-model.trim="tonExchangeRate.starCoefficient" size="mini" :controls="false" placeholder="TON" />
                </el-form-item>
              </el-form>
            </div>
            <el-table size="mini" :data="formData" border style="width: 60%">
              <el-table-column label="SKU" align="center">
                <template v-slot:default="scope">
                  {{ scope.row.sku }}
                </template>
              </el-table-column>
              <el-table-column label="SKU" align="center">
                <template v-slot:default="scope">
                  {{ scope.row.price }}
                </template>
              </el-table-column>
              <el-table-column label="TON" align="center">
                <template v-slot:default="scope">
                  <el-input v-model.trim="scope.row.tonNum" placeholder="TON" />
                </template>
              </el-table-column>
              <el-table-column label="Star" align="center">
                <template v-slot:default="scope">
                  <el-input v-model.trim="scope.row.starNum" placeholder="TON" />
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>

import { getSku, syncSkuOss, updateSkuTon } from '@/api/config/shop-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncVersion from '@/components/SyncVersion/index.vue'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
export default {
  name: 'SkuToTon',
  components: { ClearCacheApply, SyncVersion },
  data() {
    return {
      activeName: 'first',
      formData: [],
      tonExchangeRate: {
        exchangeRate: 5,
        coefficient: 3,
        starExchangeRate: 5,
        starCoefficient: 3
      }
    }
  },
  created() {
    getCommonCfg({ name: 'tonExchangeRate' }).then(res => {
      this.tonExchangeRate = res.data
    })
    this.getTables('first')
  },
  methods: {
    syncSkuOss,
    onSubmit(tableName) {
      updateSkuTon({ data: this.formData }).then(res => {
        this.msgSuccess(res.msg)
      })
    },
    getTables(tableName) {
      getSku({ type: '1,2,3,4' }).then(res => {
        this.formData = res.data
      })
    },
    handleClick(tab, event) {
      const tableName = tab.name
      this.getTables(tableName)
    },
    onCount() {
      updateCommonCfg({ data: JSON.stringify(this.tonExchangeRate), name: 'tonExchangeRate' })
      for (let i = 0; i < this.formData.length; i++) {
        const newNum = this.formData[i].price / this.tonExchangeRate.exchangeRate * this.tonExchangeRate.coefficient
        this.formData[i].tonNum = parseFloat(newNum.toFixed(2))
      }
      for (let i = 0; i < this.formData.length; i++) {
        const newNum = this.formData[i].price / this.tonExchangeRate.starExchangeRate * this.tonExchangeRate.starCoefficient
        this.formData[i].starNum = parseFloat(newNum.toFixed(0))
      }
    }
  }
}
</script>

<style scoped>
</style>
